"use client";

import { Button, message, Space, Tooltip, Typography } from "antd";
import { PARTNER_IMAGES, STATUS_CONFIG } from "../../helpers/Constants";
import { CopyOutlined, LinkOutlined } from "@ant-design/icons";

const { Text, Link } = Typography;

export function StatusPill({ status }) {
  const cfg = STATUS_CONFIG[status] ?? {
    color: "#6B7280",
    background: "#F9FAFB",
    border: "#E5E7EB",
    label: status,
  };

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        borderRadius: 20,
        padding: "3px 10px",
        color: cfg.color,
      }}
    >
      {cfg.icon} {cfg.label}
    </span>
  );
}

export function PartnerBadge({ partner }) {
  return (
    <>
      <Space size={4}>{PARTNER_IMAGES[partner?.toLowerCase()]}</Space>
    </>
  );
}

export function Chip({ label, color = "#475569", bg = "#F1F5F9", border = "#E2E8F0" }) {
  if (!label) return <Text type="secondary">-</Text>;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        background: bg,
        border: `1px solid ${border}`,
        borderRadius: 20,
        padding: "3px 10px",
        color,
        fontSize: 12,
        fontWeight: 500,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}

const copyText = (text) => {
  navigator.clipboard.writeText(text);
  message.success({ content: "Copied!", duration: 1.5 });
};

export function CopyableText({
  displayText = "",
  style,
  text,
  truncate = false,
  linkType = "",
  showIcon = true,
}) {
  const finalText = displayText || text;
  const display =
    truncate && finalText?.length > 20
      ? finalText.slice(0, 18) + "…"
      : finalText;

  const evalPrefix = () => {
    switch (linkType) {
      case "phone_number":
        return "tel:";
      default:
        return "";
    }
  };
  const linkPrefix = evalPrefix();

  const commonStyles = {
    padding: "0 4px",
    height: 20,
    fontSize: 14,
    fontWeight: 600,
    boxShadow: "none",
    whiteSpace: "break-spaces",
    ...style,
  };

  const content = (
    <>
      {display}
      {showIcon && <CopyOutlined style={{ marginLeft: 8 }} />}
    </>
  );

  return (
    <Space size={4}>
      <Tooltip title="Copy">
        {linkPrefix && (
          <Link
            href={`${linkPrefix}${text}`}
            style={commonStyles}
            onClick={() => copyText(text)}
          >
            {display}
            {showIcon && <CopyOutlined style={{ marginLeft: 8 }} />}
          </Link>
        )}
        {!linkPrefix && (
          <span
            style={{ ...commonStyles, cursor: "pointer" }}
            onClick={() => copyText(text)}
          >
            {content}
          </span>
        )}
      </Tooltip>
    </Space>
  );
}

export function TrackingLink({ href, onClick }) {
  if (!href) return <Text style={{ color: "#1e293b" }}>—</Text>;

  return (
    <>
      <Link
        href={href}
        target="_blank"
        onClick={onClick}
        style={{ fontWeight: 500, color: "#2563EB" }}
      >
        <LinkOutlined style={{ marginRight: 3 }} />
        Track
      </Link>
      <Button type="link" onClick={() => copyText(href)}>
        <CopyOutlined style={{ marginLeft: 8 }} />
      </Button>
    </>
  );
}
